const white = '#FFFFFF'
const black = '#4A4B65'

const primary = {
  '50': '#E1E6E9',
  '100': '#B3BFC8',
  '200': '#8195A4',
  '300': '#34556D',
  '400': '#284B64',
  '500': '#022B49',
  '600': '#022642',
  '700': '#012039',
  '800': '#011A31',
  '900': '#011021',
  contrastText: white,
  containedHoverBackground: 'linear-gradient(0deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), #022B49',
  outlinedHoverBackground: '#022B4914',
  outlinedRestingBackground: '#022B4980'
}

const secondary = {
  '50': '#F3E9FF',
  '100': '#E8D3FE',
  '200': '#CEA8FD',
  '300': '#B17CFB',
  '400': '#965BF7',
  '500': '#6D27F3',
  '600': '#541CD0',
  '700': '#3E13AE',
  '800': '#2A0C8C',
  '900': '#1D0774',
  contrastText: white,
  containedHoverBackground: 'linear-gradient(0deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), #6D27F3',
  outlinedHoverBackground: '#6D27F314',
  outlinedRestingBackground: '#6D27F380'
}

const info = {
  '50': '#F9EFFF',
  '100': '#F4E0FE',
  '200': '#E6C2FE',
  '300': '#D6A3FE',
  '400': '#C68CFD',
  '500': '#AC66FC',
  '600': '#A55EFC',
  '700': '#9B53FB',
  '800': '#9249FB',
  '900': '#8238FA',
  contrastText: white,
  containedHoverBackground: 'linear-gradient(0deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), #AC66FC',
  outlinedHoverBackground: '#AC66FC14',
  outlinedRestingBackground: '#AC66FC80',
  content: 'linear-gradient(0deg, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), #AC66FC',
  background: 'linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #AC66FC'
}

const success = {
  '50': '#E8FDF3',
  '100': '#D2FBE6',
  '200': '#A6F8D6',
  '300': '#76EAC5',
  '400': '#51D6B7',
  '500': '#21BBA6',
  '600': '#1DB59E',
  '700': '#18AC95',
  '800': '#14A48B',
  '900': '#0B967B',
  contrastText: black,
  containedHoverBackground: 'linear-gradient(0deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), #21BBA6',
  outlinedHoverBackground: '#21BBA614',
  outlinedRestingBackground: '#21BBA680',
  content: 'linear-gradient(0deg, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), #21BBA6',
  background: 'linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #21BBA6'
}

const error = {
  '50': '#FFEBE9',
  '100': '#FED6D4',
  '200': '#FDA9AD',
  '300': '#FB7E8F',
  '400': '#F75E82',
  '500': '#F32A6D',
  '600': '#D01E6B',
  '700': '#AE1566',
  '800': '#8C0D5D',
  '900': '#740857',
  contrastText: white,
  containedHoverBackground: 'linear-gradient(0deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), #F32A6D',
  outlinedHoverBackground: '#F32A6D14',
  outlinedRestingBackground: '#F32A6D80',
  content: 'linear-gradient(0deg, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), #F32A6D',
  background: 'linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #F32A6D'
}

const warning = {
  '50': '#FFF6E9',
  '100': '#FEEDD3',
  '200': '#FDD6A8',
  '300': '#FBB87C',
  '400': '#F79B5B',
  '500': '#F36D27',
  '600': '#F16523',
  '700': '#EF5A1D',
  '800': '#ED5017',
  '900': '#EA3E0E',
  contrastText: white,
  containedHoverBackground: 'linear-gradient(0deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), #F36D27',
  outlinedHoverBackground: '#F36D2714',
  outlinedRestingBackground: '#F36D2780',
  content: 'linear-gradient(0deg, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), #F36D27',
  background: 'linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #F36D27'
}

const grey = {
  '50': '#F8FAFC',
  '100': '#F1F5F9',
  '200': '#E2E8F0',
  '300': '#CBD5E1',
  '400': '#94A3B8',
  '500': '#64748B',
  '600': '#475569',
  '700': '#334155',
  '800': '#1E293B',
  '900': '#0F172A'
}

const colors = {
  black,
  white,
  primary,
  secondary,
  info,
  success,
  error,
  warning,
  grey
}

export default colors
